module.exports = __webpack_public_path__ + "static/media/heatstroke.03988443.svg";